import type { CurrentUserInfo } from '../types'
import { authenticatedFetch, clearCachedInitData } from './auth'
import { clearCachedUserInfo } from './mobilePaymentBarApi'

export interface DailyGift { amount: number; nextBookTime: number }
export async function claimDailyGift(category: 'chips' | 'jokers' = 'chips'): Promise<{ booked: boolean; dailyGift: DailyGift | null; jokerGift: DailyGift | null; currentUser: CurrentUserInfo }> {
    const response = await authenticatedFetch('/api/mobile-shop/claimDailyGift', { method: 'POST', body: JSON.stringify({ category }) })
    const json = await response.json()
    if (!response.ok || json.r !== true || !json.data?.currentUser) throw new Error('Der Bonus konnte nicht abgeholt werden.')
    clearCachedInitData()
    clearCachedUserInfo()
    return json.data
}
